import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=02cc196a&scoped=true&"
import script from "./orderList.js?vue&type=script&lang=js&"
export * from "./orderList.js?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=02cc196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc196a",
  null
  
)

export default component.exports